import { ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core';
import { FeatherModule } from 'angular-feather';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [FeatherModule],
})
export class ButtonComponent {
  @Input() title?: string;
  @Input() icon?: string;
}
